/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import { TIMED_ENTRY_PREFIX } from '../constants';

export const FETCH_FACILITY_DATA = `${TIMED_ENTRY_PREFIX}FETCH_FACILITY_DATA`;
export const FETCH_FACILITY_DATA_SUCCESS = `${TIMED_ENTRY_PREFIX}FETCH_FACILITY_DATA_SUCCESS`;
export const FETCH_FACILITY_DATA_ERROR = `${TIMED_ENTRY_PREFIX}FETCH_FACILITY_DATA_ERROR`;
export const SET_FETCH_FACILITY_DATA_STATUS = `${TIMED_ENTRY_PREFIX}SET_FETCH_FACILITY_DATA_STATUS`;

export function fetchFacilityDataSuccess(data) {
    return {
        type: FETCH_FACILITY_DATA_SUCCESS,
        payload: data,
    };
}

export function fetchFacilityDataError(error) {
    return {
        type: FETCH_FACILITY_DATA_ERROR,
        payload: error,
    };
}

export function setFetchFacilityDataStatus(status) {
    return {
        type: SET_FETCH_FACILITY_DATA_STATUS,
        payload: status,
    };
}

export function fetchFacilityData(facilityId) {
    return {
        type: FETCH_FACILITY_DATA,
        payload: facilityId,
    };
}
